import { AccountView } from './mapAccount';

/** Client-picker search: case-insensitive substring over name, manager, email.
 *  Empty/whitespace query returns the list unchanged. */
export const filterCompanies = (
  rows: AccountView[],
  query: string
): AccountView[] => {
  const q = query.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter(
    (c) =>
      c.name.toLowerCase().includes(q) ||
      c.managerName.toLowerCase().includes(q) ||
      c.email.toLowerCase().includes(q)
  );
};
